import {motion} from 'framer-motion';
import './story-page.css';

const chapters=[
  {
    number:'序',
    enNumber:'PROLOGUE',
    titleZh:'淵在客人到來前甦醒',
    titleEn:'The Abyss Wakes Before the Guest Arrives',
    textZh:'客人遞交預約的那一刻，問診票尚未送到料理長手中，旬之淵的某一層已先亮起。它聞到的不是想吃什麼，而是那顆尚未能以語言說明的心。',
    textEn:'The instant a guest reserves, a floor of Shun no Fuchi begins to glow. It senses not what they wish to eat, but the heart they cannot yet put into words.',
    mark:'聞'
  },
  {
    number:'壱',
    enNumber:'CHAPTER I',
    titleZh:'料理長聞心，定下旬題',
    titleEn:'The Head Chef Listens and Sets the Question',
    textZh:'料理長以「聞心」傾聽淵之騷動，從發光的水層、魚群與殘留記憶之中，定下一道只屬於今晚的旬題。先付組解讀題目，選出最適合下淵的板前。',
    textEn:'Through the art of listening to the heart, the head chef reads the glowing water, fish and memories, then sets a seasonal question that belongs to this night alone.',
    mark:'問'
  },
  {
    number:'弐',
    enNumber:'CHAPTER II',
    titleZh:'紅澪與玉澄，向百層以下出發',
    titleEn:'Kuremio and Tamasumi Descend',
    textZh:'紅澪循著食材之中未完的情緒逆流而行；玉澄守著不滅的火，讓隊伍在深壓與失落古法之中仍保持安定。她們追尋的並非最稀有的食材，而是最適合回答此刻的鮮。',
    textEn:'Kuremio follows unfinished feelings upstream. Tamasumi guards the flame that keeps the team steady through pressure and forgotten technique.',
    mark:'淵'
  },
  {
    number:'参',
    enNumber:'CHAPTER III',
    titleZh:'每一層，都是一道被保存的記憶',
    titleEn:'Every Floor Preserves a Memory',
    textZh:'淺層保存洄游與晨光，中層以深海重壓考驗持刀之心，深層埋著失傳技法與板前執念。九十一層以後，旬神只向能與其血脈共鳴的人顯現。',
    textEn:'The shallows preserve migration and morning light. The deep tests the hand beneath crushing pressure. Ancient floors hold techniques and obsessions lost to time.',
    mark:'鮮'
  },
  {
    number:'終',
    enNumber:'FINAL COURSE',
    titleZh:'一席完成，答案化成客人的心',
    titleEn:'The Answer Becomes the Guest’s Heart',
    textZh:'板前帶著尋回的鮮味返回料亭。刀、火、米與甘味依次落席，直到客人終於理解那份一直未能言明的情緒。同一份鮮不會再來，同一種心境也是。',
    textEn:'The itamae return with the answer. Blade, fire, rice and sweetness become one offering, until the guest recognizes the feeling that could not be spoken.',
    mark:'心'
  }
];

export default function StoryPage({lang='zh-Hant'}){
  const english=lang==='en';

  return(
    <section className="story-page">
      <header className="story-hero">
        <div className="story-hero__copy">
          <span>THE STORY OF SHUNSHIN · 旬心物語</span>
          <h1>
            {english
              ? 'One Guest. One Question. One Descent Into The Abyss.'
              : '一位客人，一道旬題，一次向淵而下。'}
          </h1>
          <p>
            {english
              ? 'The complete journey behind a single omakase offering.'
              : '一席おまかせ背後，由聞心、下淵到獻食的完整旅程。'}
          </p>
        </div>
        <div className="story-hero__seal" aria-hidden="true">
          <small>一期</small>
          <strong>一會</strong>
        </div>
      </header>
      <div className="story-chapters">
        {chapters.map((chapter,index)=>(
          <motion.article
            className="story-chapter"
            initial={{opacity:0,y:45}}
            whileInView={{opacity:1,y:0}}
            viewport={{once:true,amount:.3}}
            transition={{duration:.75}}
            key={chapter.number}
          >
            <div className="story-chapter__number">
              <small>{chapter.enNumber}</small>
              <strong>{chapter.number}</strong>
            </div>
            <div className="story-chapter__copy">
              <span>{String(index+1).padStart(2,'0')} · SHUNSHIN CHRONICLE</span>
              <h2>{english?chapter.titleEn:chapter.titleZh}</h2>
              <p>{english?chapter.textEn:chapter.textZh}</p>
            </div>
            <b className="story-chapter__mark" aria-hidden="true">
              {chapter.mark}
            </b>
          </motion.article>
        ))}
      </div>
      <blockquote className="story-ending">
        <span>ACADEMY RULE · 01</span>
        <p>
          {english
            ? 'Offer the unspoken heart with once-in-a-lifetime freshness.'
            : '以一期一會之鮮，獻未能言之心。'}
        </p>
      </blockquote>
    </section>
  );
}